
<div class="general-settings d-sm-flex flex-column" [formGroup]="settingsForm">
    <h3>Knowledge scope:</h3>
    <p>
        Leave both fields empty to make this file global. Scoped files are available only when the active chatbot
        brand and resolved product-feed market match.
    </p>
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Brand Domain</mat-label>
        <input matInput formControlName="brandDomain" placeholder="brand.example">
        @if (settingsForm.get('brandDomain')?.hasError('maxlength')) {
            <mat-error>Brand domain must be at most 253 characters.</mat-error>
        }
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Market</mat-label>
        <input matInput formControlName="market" placeholder="Norway">
        @if (settingsForm.get('market')?.hasError('maxlength')) {
            <mat-error>Market must be at most 128 characters.</mat-error>
        }
    </mat-form-field>

    <h3>Upload file:</h3>
    <div class="general-settings d-sm-flex flex-column">
        <div class="button-group" matTooltip="Please save before uploading" [matTooltipDisabled]="!settingsForm.touched" matTooltipPosition="above">
            <button type="button" color="primary" mat-raised-button (click)="fileInput.click()" [disabled]="settingsForm.touched" matTooltip="">Choose File</button>
            <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
            <button mat-raised-button color="primary" (click)="uploadFile()" [disabled]="!selectedFile || settingsForm.touched">
                Upload File
            </button>
            <button mat-raised-button color="primary" (click)="publishFile()" [disabled]="!isFileUploaded || settingsForm.touched">
                Publish File
            </button>
        </div>
    </div>
</div>
